export default function InitCountdown() {
    const countDownWrapper = document.getElementById('countdown');
    if(countDownWrapper === null)
        return;
        
	const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    const countDown = new Date(countDownWrapper.getAttribute('data-target')).getTime();
    const days = document.getElementById("days");
    const hours = document.getElementById("hours");
    const minutes = document.getElementById("minutes");
    const seconds = document.getElementById("seconds");
    
    let inverval = setInterval(function() {    

        let now = new Date().getTime();
        let distance = countDown - now;

        days.innerText = Math.floor(distance / (day)),
        hours.innerText = Math.floor((distance % (day)) / (hour)),
        minutes.innerText = Math.floor((distance % (hour)) / (minute)),
        seconds.innerText = Math.floor((distance % (minute)) / second);

        // hide countdown if 
        if (distance < 0) {
            countDownWrapper.parentElement.style.display = "none";

            clearInterval(inverval);
        }
    }, 0);
}